import React from 'react';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  '& .MuiTooltip-tooltip': {
    backgroundColor: '#d5dbdb', 
    color: 'red', 
  }
}));

const CustomTooltip = ({ title, children, ...props }) => {
  return (
    <StyledTooltip title={
        <div className="flex items-center font-bold gap-2">
          <WarningAmberIcon/>
         {title}
        </div>
      } {...props}>
      {children}
    </StyledTooltip>
  );
};

export default CustomTooltip;
